module.exports = __webpack_public_path__ + "img/cnId.7c0e2bfb.png";